/**
 * Scripts du thème Transports Sheeren.
 */
(function () {
	'use strict';

	// --- Menu mobile : ouverture / fermeture du panneau ---
	var panel = document.getElementById( 'pdw-mobile-menu' );

	if ( panel ) {
		var openMenu = function () {
			panel.classList.add( 'show' );
			document.documentElement.classList.add( 'pdw-menu-open' );
		};
		var closeMenu = function () {
			panel.classList.remove( 'show' );
			document.documentElement.classList.remove( 'pdw-menu-open' );
		};

		document.querySelectorAll( '.pdw-mobile-menu-open' ).forEach( function ( el ) {
			el.addEventListener( 'click', function ( e ) {
				e.preventDefault();
				openMenu();
			} );
		} );

		// Bouton de fermeture (dans le panneau) + overlay (sibling .pdw-mobile-menu-close)
		document.querySelectorAll( '.pdw-mobile-menu-close' ).forEach( function ( el ) {
			el.addEventListener( 'click', function ( e ) {
				e.preventDefault();
				closeMenu();
			} );
		} );

		document.addEventListener( 'keydown', function ( e ) {
			if ( 'Escape' === e.key ) {
				closeMenu();
			}
		} );
	}
})();

// --- Header collant au scroll : barre bordeaux opaque au-delà d'un seuil ---
(function () {
	'use strict';

	var header = document.querySelector( '.pdw-header' );
	if ( ! header ) {
		return;
	}
	var threshold = 80;
	var ticking   = false;
	var apply = function () {
		header.classList.toggle( 'pdw-header--stuck', window.scrollY > threshold );
		ticking = false;
	};
	var onScroll = function () {
		if ( ! ticking ) {
			window.requestAnimationFrame( apply );
			ticking = true;
		}
	};
	window.addEventListener( 'scroll', onScroll, { passive: true } );
	apply();
})();

// --- Onglets (section « cartes » présentée en tabs) ---
(function () {
	'use strict';

	document.querySelectorAll( '.pdw-tabs' ).forEach( function ( root ) {
		var tabs   = root.querySelectorAll( '.pdw-tabs__tab' );
		var panels = root.querySelectorAll( '.pdw-tabs__panel' );
		if ( tabs.length < 2 ) {
			return;
		}
		var activate = function ( i ) {
			tabs.forEach( function ( t, j ) {
				var on = i === j;
				t.classList.toggle( 'is-active', on );
				t.setAttribute( 'aria-selected', on ? 'true' : 'false' );
				t.tabIndex = on ? 0 : -1;
			} );
			panels.forEach( function ( p, j ) {
				var on = i === j;
				p.classList.toggle( 'is-active', on );
				if ( on ) {
					p.removeAttribute( 'hidden' );
				} else {
					p.setAttribute( 'hidden', '' );
				}
			} );
		};
		tabs.forEach( function ( t, i ) {
			t.addEventListener( 'click', function () { activate( i ); } );
			t.addEventListener( 'keydown', function ( e ) {
				var n = tabs.length, k;
				if ( 'ArrowDown' === e.key || 'ArrowRight' === e.key ) { k = ( i + 1 ) % n; }
				else if ( 'ArrowUp' === e.key || 'ArrowLeft' === e.key ) { k = ( i - 1 + n ) % n; }
				else { return; }
				e.preventDefault();
				activate( k );
				tabs[ k ].focus();
			} );
		} );
	} );
})();

// --- Slider Truck School (fondu simple : prev / next + compteur) ---
(function () {
	'use strict';

	document.querySelectorAll( '.pdw-truckschool__slider' ).forEach( function ( slider ) {
		var slides  = slider.querySelectorAll( '.pdw-truckschool__slide' );
		var counter = slider.querySelector( '.pdw-truckschool__counter' );
		var prev    = slider.querySelector( '[data-slider-prev]' );
		var next    = slider.querySelector( '[data-slider-next]' );
		if ( slides.length < 2 ) {
			return;
		}
		var index = 0;
		var show  = function ( n ) {
			index = ( n + slides.length ) % slides.length;
			slides.forEach( function ( s, i ) {
				s.classList.toggle( 'is-active', i === index );
			} );
			if ( counter ) {
				counter.textContent = ( index + 1 ) + '/' + slides.length;
			}
		};
		if ( prev ) {
			prev.addEventListener( 'click', function () { show( index - 1 ); } );
		}
		if ( next ) {
			next.addEventListener( 'click', function () { show( index + 1 ); } );
		}
		show( 0 );
	} );
})();

// --- Timeline : reveal au scroll + remplissage progressif du spine ---
(function () {
	'use strict';

	var timelines = document.querySelectorAll( '.js-timeline' );
	if ( ! timelines.length ) {
		return;
	}
	var reduce = window.matchMedia && window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	timelines.forEach( function ( tl ) {
		var items    = tl.querySelectorAll( '.pdw-timeline__item' );
		var progress = tl.querySelector( '.pdw-timeline__progress' );
		var list     = tl.querySelector( '.pdw-timeline__list' );

		if ( ! reduce ) {
			tl.classList.add( 'is-armed' );
		}

		// Reveal des étapes une à une
		if ( 'IntersectionObserver' in window ) {
			var io = new IntersectionObserver( function ( entries ) {
				entries.forEach( function ( e ) {
					if ( e.isIntersecting ) {
						e.target.classList.add( 'is-visible' );
						io.unobserve( e.target );
					}
				} );
			}, { rootMargin: '0px 0px -12% 0px', threshold: 0.2 } );
			items.forEach( function ( it ) { io.observe( it ); } );
		} else {
			items.forEach( function ( it ) { it.classList.add( 'is-visible' ); } );
		}

		// Remplissage du spine (hauteur pilotée par la position de scroll)
		if ( progress && list ) {
			if ( reduce ) {
				progress.style.height = '100%';
			} else {
				var update = function () {
					var rect = list.getBoundingClientRect();
					var vh   = window.innerHeight || document.documentElement.clientHeight;
					var filled = ( vh * 0.6 - rect.top ) / rect.height;
					filled = Math.max( 0, Math.min( 1, filled ) );
					progress.style.height = ( filled * 100 ) + '%';
				};
				var ticking = false;
				var onScroll = function () {
					if ( ! ticking ) {
						window.requestAnimationFrame( function () { update(); ticking = false; } );
						ticking = true;
					}
				};
				window.addEventListener( 'scroll', onScroll, { passive: true } );
				window.addEventListener( 'resize', onScroll, { passive: true } );
				update();
			}
		}
	} );
})();

// --- Reveal générique au scroll (fade-up) + compteurs animés ---
(function () {
	'use strict';

	var reduce = window.matchMedia && window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
	if ( reduce || ! ( 'IntersectionObserver' in window ) ) {
		return; // no-JS / reduced motion → contenu visible, pas de compteur
	}
	// Le fade-up reste hors de la page d'accueil (rendu conçu sans reveal) ;
	// les compteurs, eux, tournent partout — la home est justement leur place.
	var isHome = document.body.classList.contains( 'home' );

	// 1) Fade-up des blocs (contenu, cartes, stats)
	var revealEls = isHome ? [] : document.querySelectorAll(
		'.pdw-contenu__single, .pdw-contenu__grid, .pdw-cartes__head, .pdw-cartes__card, .pdw-chiffres__item'
	);
	if ( revealEls.length ) {
		var ioR = new IntersectionObserver( function ( entries ) {
			entries.forEach( function ( e ) {
				if ( e.isIntersecting ) {
					e.target.classList.add( 'is-inview' );
					ioR.unobserve( e.target );
				}
			} );
		}, { rootMargin: '0px 0px -10% 0px', threshold: 0 } ); // 0 : un bloc plus haut que l'écran n'atteindrait jamais 12 % visibles

		revealEls.forEach( function ( el ) {
			el.classList.add( 'pdw-reveal' );
			// léger décalage en cascade pour les cartes / stats voisines
			if ( el.classList.contains( 'pdw-cartes__card' ) || el.classList.contains( 'pdw-chiffres__item' ) ) {
				var idx = 0, s = el.previousElementSibling;
				while ( s ) { idx ++; s = s.previousElementSibling; }
				el.style.transitionDelay = ( Math.min( idx, 6 ) * 0.08 ) + 's';
			}
			ioR.observe( el );
		} );
	}

	// 2) Compteurs animés (.pdw-chiffres__number : "150+", "3", "70+"…)
	var nums = document.querySelectorAll( '.pdw-chiffres__number' );
	if ( nums.length ) {
		var animate = function ( el ) {
			var raw    = el.textContent.trim();
			var target = parseInt( raw.replace( /\D/g, '' ), 10 );
			if ( ! target || target > 100000 ) { return; }
			var suffix = raw.replace( /[0-9\s]/g, '' );   // "+" éventuel
			var start  = null;
			var step   = function ( ts ) {
				if ( ! start ) { start = ts; }
				var p     = Math.min( ( ts - start ) / 1400, 1 );
				var eased = 1 - Math.pow( 1 - p, 3 );
				el.textContent = Math.round( eased * target ) + suffix;
				if ( p < 1 ) { window.requestAnimationFrame( step ); }
			};
			window.requestAnimationFrame( step );
		};
		var ioN = new IntersectionObserver( function ( entries ) {
			entries.forEach( function ( e ) {
				if ( e.isIntersecting ) {
					animate( e.target );
					ioN.unobserve( e.target );
				}
			} );
		}, { threshold: 0.5 } );
		nums.forEach( function ( n ) { ioN.observe( n ); } );
	}
})();

// --- Slider générique [data-pdw-slider] (translateX : flèches / puces / compteur / swipe) ---
(function () {
	'use strict';

	document.querySelectorAll( '[data-pdw-slider]' ).forEach( function ( root ) {
		var track  = root.querySelector( '[data-slider-track]' );
		if ( ! track ) { return; }
		var slides = Array.prototype.slice.call( track.children );
		var total  = slides.length;
		if ( total < 2 ) { return; }

		var prev    = root.querySelector( '[data-slider-prev]' );
		var next    = root.querySelector( '[data-slider-next]' );
		var dotsBox = root.querySelector( '[data-slider-dots]' );
		var counter = root.querySelector( '[data-slider-counter]' );
		var index   = 0;

		// Puces
		var dots = [];
		if ( dotsBox ) {
			slides.forEach( function ( s, i ) {
				var d = document.createElement( 'button' );
				d.type = 'button';
				d.className = 'pdw-slider__dot';
				d.setAttribute( 'aria-label', 'Aller à la diapositive ' + ( i + 1 ) );
				d.addEventListener( 'click', function () { go( i ); reveal(); } );
				dotsBox.appendChild( d );
				dots.push( d );
			} );
		}

		var pad2 = function ( n ) { return ( n < 10 ? '0' : '' ) + n; };

		function go( i ) {
			index = ( i + total ) % total;
			track.style.transform = 'translateX(' + ( -index * 100 ) + '%)';
			slides.forEach( function ( s, n ) {
				s.setAttribute( 'aria-hidden', n === index ? 'false' : 'true' );
				s.inert = n !== index; // sinon les liens des diapos masquées restent focusables
			} );
			dots.forEach( function ( d, n ) {
				d.classList.toggle( 'is-active', n === index );
				// aria-selected n'est permis que sur role=tab : une puce est un simple bouton
				if ( n === index ) { d.setAttribute( 'aria-current', 'true' ); } else { d.removeAttribute( 'aria-current' ); }
			} );
			if ( counter ) { counter.textContent = pad2( index + 1 ) + ' / ' + pad2( total ); }
			fitHeight();
		}

		// Le track suit la hauteur de la diapo active (sinon blanc sous les diapos courtes)
		function fitHeight() { track.style.height = slides[ index ].offsetHeight + 'px'; }
		window.addEventListener( 'resize', fitHeight, { passive: true } );
		window.addEventListener( 'load', fitHeight );

		// Mobile : une diapo peut dépasser l'écran, les flèches sont dessous. Après navigation, on remonte
		// au début du slider (sous le header collé), sinon on atterrit au milieu de la diapo suivante.
		function reveal() {
			var header = document.querySelector( '.pdw-header' );
			var top    = root.getBoundingClientRect().top - ( header ? header.offsetHeight : 0 ) - 16;
			if ( top < 0 ) { window.scrollBy( { top: top, behavior: 'smooth' } ); }
		}

		if ( prev ) { prev.addEventListener( 'click', function () { go( index - 1 ); reveal(); } ); }
		if ( next ) { next.addEventListener( 'click', function () { go( index + 1 ); reveal(); } ); }

		// Clavier (flèches ← →) quand le focus est dans le slider
		root.addEventListener( 'keydown', function ( e ) {
			if ( e.key === 'ArrowLeft' )  { go( index - 1 ); }
			if ( e.key === 'ArrowRight' ) { go( index + 1 ); }
		} );

		// Swipe tactile
		var x0 = null;
		track.addEventListener( 'touchstart', function ( e ) { x0 = e.touches[0].clientX; }, { passive: true } );
		track.addEventListener( 'touchend', function ( e ) {
			if ( x0 === null ) { return; }
			var dx = e.changedTouches[0].clientX - x0;
			if ( Math.abs( dx ) > 40 ) { go( dx < 0 ? index + 1 : index - 1 ); }
			x0 = null;
		}, { passive: true } );

		go( 0 );
	} );
})();
